import Swal from 'sweetalert2';
import axios from 'axios';
import API_URL from '../config/apiConfig';
import { useAuth } from '../AuthContext';

const useErrorHandler = () => {
    const authInfo = useAuth();
    const userName = authInfo.authToken?.userName || 'Utilisateur inconnu';

    const handleError = async (title, message, location, error = null) => {
        console.error(`[${location}]`, message, error?.toString());

        // Affiche une alerte SweetAlert
        Swal.fire({
            icon: 'error',
            title,
            text: message,
            confirmButtonText: 'OK'
        });

        // Envoie le log au serveur si possible
        if (error) {
            try {
                await axios.post(`${API_URL}/log-client-error`, {
                    error: `${userName} - ${error.toString()}`,
                    location
                });
            } catch (logErr) {
                console.warn('Erreur envoi log client:', logErr.toString());
            }
        }
    };

    return handleError;
};

export default useErrorHandler;
